import * as classNames from "classnames";
import * as React from "react";
import { scrollPositions } from "source/app/presentation/ScrollPositionTracker";
import { INavigationMenuItem } from "source/app/presentation/Shared/ActivePanel/NavigationMenu/Helpers/INavigationMenuItem";
import { NavMenuItemBadge } from "source/app/presentation/Shared/ActivePanel/NavigationMenu/NavigationMenuItem/Badge/NavMenuItemBadge";
import { EPanelId } from "source/app/services/Shared/EPanelId";
import { Sounds } from "source/app/services/Sound/Sounds";
import UI from "source/app/services/UI/UI";
import Player from "../../../../../domain/Player";
import Hyperlink from "../../../Link/Hyperlink";
import RPGIcon from "../../../RPGIcon/RPGIcon";
import { Style, StyleClass } from "../../../Styles/CSS";
import * as styles from "./NavigationMenuItem.css";
import { EBadgeColor } from "./NavigationMenuItemBadge/EBadgeColor/EBadgeColor";
import { LoadPanel } from "../../Helpers/LoadPanel";

export function NavigationMenuItem({
    menuItem,
    activePanelTitle,
}: {
    menuItem: INavigationMenuItem;
    activePanelTitle: EPanelId;
}) {
    return (
        <Hyperlink
            whenClicked={() => {
                Sounds.metal_clang_short_2.Play();

                const scrollPosition = scrollPositions.get(menuItem.id)!;
                window.scroll(0, scrollPosition);

                const panelId = menuItem.id;
                LoadPanel(panelId);
            }}
        >
            <NavMenuItemContainer
                menuItem={menuItem}
                activePanelTitle={activePanelTitle}
            />
        </Hyperlink>
    );
}

function NavMenuItemContainer({
    menuItem,
    activePanelTitle,
}: {
    menuItem: INavigationMenuItem;
    activePanelTitle: EPanelId;
}) {
    const badge = menuItem.badge;
    const isActive = menuItem.id === activePanelTitle;

    return (
        <div
            data-tip={menuItem.title}
            className={classNames(styles.item, {
                [styles.active]: isActive,
            })}
        >
            <Icon menuItem={menuItem} isActive={isActive} />
            <NavMenuItemBadge
                badgeText={badge ? badge.value : undefined}
                backgroundColor={
                    badge ? badge.backgroundColor : EBadgeColor.darkred
                }
                isPanelActive={isActive}
            />
        </div>
    );
}

function Icon({
    menuItem,
    isActive,
}: {
    menuItem: INavigationMenuItem;
    isActive: boolean;
}) {
    const activeLinkClass = StyleClass(`navMenuItem_activeLink_sharedStyle`, {
        color: "white",
        textShadow: "none",
    });

    const flameStyleClass = StyleClass(`flameStyle_${menuItem.id}`, {
        background: "linear-gradient(to bottom, red, orange)",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        WebkitTextFillColor: "transparent",
    });

    const shouldAddLinksFlameStyle =
        menuItem.id === EPanelId.Hero && Player.IsTooFarAhead;

    return (
        <span
            className={classNames(styles.icon, {
                [activeLinkClass]: isActive,
            })}
            {...Style(`navMenuItemIconColor_${menuItem.id}`, {
                color: isActive ? `rgba(226, 237, 229, 0.98)` : `rgba(167, 190, 188, 0.76)`,
            })}
        >
            <RPGIcon
                icon={menuItem.icon}
                withClass={classNames({
                    [flameStyleClass]: shouldAddLinksFlameStyle,
                })}
            />
        </span>
    );
}
